import {
  PromptModelConfig,
  PromptModelVersion,
} from '~/api/sylvanus/typedefs.autogen';
import { sylvanus } from '~/services/serviceInstances';
import { Uuid } from '~/types/Uuid';

interface Request {
  modelId: Uuid;
  config: PromptModelConfig;
}

type Response = PromptModelVersion;

export const createPromptModelVersion = async ({
  modelId,
  config,
}: Request): Promise<Response> => {
  return sylvanus.post(`/model/${modelId}/version`, {
    config,
  });
};
